import { colors } from '../../colors';
var para = {
  messageColor: colors.copper
};
export default para;